<template>
  <el-dialog custom-class="medium-dialog" title="扫码入库" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <div class="search-content">
      {{this.controlData.billmap?this.controlData.billmap[0].seedcode:''}}&nbsp;&nbsp;{{this.controlData.billmap?this.controlData.billmap[0]["产品名称"]:''}}
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;" class="query-table">
        <tr>
          <td style="text-align: center;width: 60px">序号</td>
          <td style="text-align: center;width:100px;">R/L</td>
          <td style="text-align: center;width:140px;">度数</td>
          <td style="text-align: center;width:200px;">商品条码</td>
          <td style="text-align: center;width:300px;">{{noscan?'出库数量':'唯一码'}}</td>
        </tr>
        <tr v-for="(item,i) in scancodes">
          <td>{{i+1}}</td>
          <td class="left">{{item["R/L"]}}</td>
          <td>{{getPackagesize(item.packagesize)}}</td>
          <td class="left"><input v-model="item.goodsbarcode" style="width: 90%" onfocus="this.select()" @change="replaceItemCode(item,'goodsbarcode')"/></td>
          <td style="text-align: right;"><input v-model="item.storegoodsbarcode" style="width: 90%" onfocus="this.select()" @change="replaceItemCode(item,'storegoodsbarcode')"/></td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogFormVisible=false">取 消</el-button>
      <el-button type="primary" @click="saveData" :loading="loading">确定收货</el-button>
      <el-input style="width: 130px" size="small" v-if="noscan" v-model="goodsbarcode" placeholder="扫商品条码"
                onfocus="this.select()" @keyup.enter.native="selectbarcode()"></el-input>
      <el-input style="width: 160px" size="small" v-if="!noscan" v-model="storegoodsbarcode" placeholder="核对供应商唯一码"
                onfocus="this.select()"  @keyup.enter.native="chechBarCode()"></el-input>
    </div>
  </el-dialog>
</template>

<script>
  import {listData} from '@/api/set/jxcstoregoodsbarcode';
      import {bardetail} from '@/api/set/jxcgoodsbarcode';
      import {getGoBack,orderStore,orderStoreBatch,getLogisticCode,getEssilorBackinfo} from '@/api/ossi'

      export default {
        name: "ScanCodeSupplyer",
        data() {
      return {
        isshowqr: false,
        loading:false,
        issale: false,
        aftersend:false,//补推操作
        noscan:false,
        scancodes: [],
        SpiltData:[],
        scancodesback:[],
        ordertype:'',
        posttxt:{},
        storegoodsbarcode: '',
        goodsbarcode:'',
        pcustomerserial:'',
        checkcodes:false,
        dmscode:'',
        supplytaskid:'',
        certs: [],
        dialogFormVisible: false,
        postSuplyData:{},
        saletype:'',
        controlData:{},
      }
    },
    methods: {
      replaceItemCode(item,cols) {
        item[cols] = this.replaceCode(item[cols]);
      },
      getPackagesize(Packagesize) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        var ps = JSON.parse(Packagesize);
        var rl = '';
        if (ps.type)
          rl = ps.type + '，';

        return rl + 'S：' + ps.Y + '，C：' + ps.X;
      },
      selectbarcode() {//商品光度码
        if (!this.goodsbarcode)
          return;

        var obj = {
          barcode: this.goodsbarcode
        }
        this.goodsbarcode = '';
        bardetail(obj).then(response => {
          this.goodsbar = response.data.obj
          //商品不存在提示
          if (this.goodsbar == undefined) {
            this.$message({message: '条码无效！', type: 'error'})
            return
          }
          if (this.goodsbar.seedcode != this.scancodes[0].seedcode) {
            this.$message({message: '商品不正确！', type: 'error'})
            return
          }
          var hasV=false;
          for (let i in this.scancodes) {
            if (!this.scancodes[i].goodsbarcode && this.scancodes[i].packagesize == this.goodsbar.packagesize) {
              this.scancodes[i].goodsbarcode = this.goodsbar.barcode;
              if (this.noscan)
                this.scancodes[i].storegoodsbarcode = 1;
              hasV = true;
              break;
            }
          }
          if(!hasV){
            this.$message({message: '条码无法匹配！', type: 'error'})
          }
        })
      },
      parseStr(str){
        var result = '';
        for(var i= 0;i<str.length;i++){
          var temp = str.charAt(i);
          var code = temp.charCodeAt();
          if('a' <= temp && temp <= 'z'){
            temp= String.fromCharCode(code-32);
          } else if('A' <= temp && temp <= 'Z'){
            temp= String.fromCharCode(code+32);
          }

          result += temp;
        }
        return result;
      },
      replaceCode(str){
        if(str.indexOf('HTTP')>-1){
          str=this.parseStr(str);
        }
        if(str.indexOf('?')>-1){
          str=str.substr(str.lastIndexOf('?')+1);
        }
        if(str.indexOf('/')>-1){
          str=str.substr(str.lastIndexOf('/')+1);
        }
        return str;
      },
      error(msg, id) {
        this.$message({
          message: msg,
          type: 'error'
        })
        if (id)
          this.$refs[Object.keys(this.$refs)[id]].focus();
      },
      chechBarCode(){
        if(!this.checkcodes){
          this.checkcodes=true;
          for(let i in this.scancodes){
            this.scancodes[i].supplybarcode=this.scancodes[i].storegoodsbarcode;
            this.scancodes[i].storegoodsbarcode='';
          }
        }

        var barcode = this.replaceCode(this.storegoodsbarcode);
        this.storegoodsbarcode = ''
        var hasValue=false;
        for(let i in this.scancodes){
          if(this.scancodes[i].supplybarcode==barcode){
            this.scancodes[i].storegoodsbarcode=barcode;
            hasValue=true;
            break;
          }
        }

        if(!hasValue)
          this.error('唯一码和依视路推送的编码不一致！')
      },
      saveData() {
        var tracking_number_dict = {};
        this.scancodesback=[]
        this.loading = true
        //判断唯一码是否唯一
        if (this.scancodes.length == 0) {
          if (this.ordertype == 'GeneralOrder') {//一般订单 直接做入库
            var items = this.posttxt.Head.Items
            for (let i in items) {
              tracking_number_dict[items[i].ItemCode] = items[i].ItemQuantity;
            }
            this.scancodesback=this.scancodes
            this.postTot(tracking_number_dict);
            return
          }
          else {
            this.error('缺失扫码数据！')
            this.loading = false
            return
          }
        }

        //批量采购的都是现片
        var type = this.supplyBack.type;//定制片buy&sale；

        var scancodelist = this.scancodes
        var hasStore = false;
        for (let i in scancodelist) {
          if (scancodelist[i].storegoodsbarcode) {
            hasStore = true
          } else {
            continue;//不处理
          }
          if (this.ordertype != 'PieceLensOrder') {//批量单
            if (!scancodelist[i].goodsbarcode) {
              this.error('商品条码必填')
              this.loading = false
              return
            }


            var hasValue = false;
            for (let key in tracking_number_dict) {
              if (key == scancodelist[i].goodsbarcode) {
                hasValue = true;
                if (this.noscan) {
                  tracking_number_dict[key]=tracking_number_dict[key]+1;
                } else {
                  tracking_number_dict[key].push(scancodelist[i].storegoodsbarcode)
                }
              }
            }
            if (!hasValue) {
              var side = []
              side.push(scancodelist[i].storegoodsbarcode)
              tracking_number_dict[scancodelist[i].goodsbarcode] = this.noscan ? 1 : side;
            }
          }else {
            var hasValue = false;
            for (let key in tracking_number_dict) {
              if (key == scancodelist[i]["R/L"]) {
                hasValue = true;
                tracking_number_dict[key].push(scancodelist[i].storegoodsbarcode)
              }
            }
            if (!hasValue) {
              var side = []
              side.push(scancodelist[i].storegoodsbarcode)
              tracking_number_dict[scancodelist[i]["R/L"]] = this.noscan ? 1 : side;
            }
          }
          this.scancodesback.push(scancodelist[i]);
        }
        if (!hasStore) {
          this.error('请填写唯一码！')
          this.loading = false
          return
        }

        this.postTot(tracking_number_dict);
      },
      postTot(tracking_number_dict) {
        var trackingData = {
          params: {
            data: {
              nba_reference: this.dmscode,
              replace: true,
              tracking_number_dict: tracking_number_dict
            }
          }
        };
        //console.log(trackingData)
        this.postSuplyData = {
          saleout: JSON.stringify(trackingData),
          taskid: this.supplytaskid,
          pcustomerserial: this.pcustomerserial
        };
        this.postPurchaseInFirst();
      },
      postPurchaseInFirst() {//出入库
        if (this.supplytaskid == 'buysplit') {
          this.postSuplyData.saleout=JSON.stringify(this.SpiltData);
          orderStoreBatch(this.postSuplyData).then(response => {
            if (response.data.msg == '库存变动已成功推送依视路！') {
              this.$message({
                message: response.data.msg,
                type: 'success'
              })
              this.dialogFormVisible = false
              if (this.aftersend) {
                //补推操作
              } else {
                this.$emit("scancodeedit", this.scancodesback)
              }
            } else {
              this.error(response.data.msg.replace('None', ''));
              this.loading = false
            }
          });
          return;
        }

        orderStore(this.postSuplyData).then(response => {
          if (response.data.msg == '库存变动已成功推送依视路！') {
            this.$message({
              message: response.data.msg,
              type: 'success'
            })
            this.dialogFormVisible = false
            if (this.aftersend) {
              //补推操作
            } else {
              this.$emit("scancodeedit", this.scancodesback)
            }
          } else {
            this.error(response.data.msg.replace('None', ''));
            this.loading = false
          }
        });
      },
      postPurchaseIn() {

      },
      show(controlData, scan, isshowqr) {
        this.loading = true;
        this.controlData = controlData;
        this.dmscode = ''
        this.aftersend=controlData.aftersend;
        if(this.aftersend){
          isshowqr=true;
        }
        this.issale = controlData.issale;
        this.pcustomerserial = controlData.pcustomerserial;
        this.supplytaskid = controlData.supplytaskid;
        this.ordertype = ''
        this.checkcodes=false

        var  existType=false;
        var seedcode=controlData.billmap[0]["seedcode"];
        for(let i in controlData.billmap){
          if(controlData.billmap[i].packagesize) {
            seedcode=controlData.billmap[i]["seedcode"];
            if (controlData.billmap[i].packagesize.indexOf('type') > -1)
              existType = true;
          }
        }

        this.supplyBack = {}
        this.noscan = false;
        if (this.controlData.billmap[0]["产品名称"].indexOf("微星") == 0) {
          this.noscan = true;
        }

        this.isshowqr = isshowqr;
        this.dialogFormVisible = true
        if (!isshowqr) {
          listData({inordernum: controlData.erpserial}).then(response => {
            this.scancodes = response.data.obj
          });
          return;
        }

        var scancodes = [];//JSON.parse(JSON.stringify(scan))
        this.scancodes = scancodes;


        if(this.supplytaskid=='buysplit') {
          this.bindScanSpilt(seedcode);
          return;
        }

        //取依视路传过来的唯一码
        getGoBack({taskid: controlData.supplytaskid}).then(response => {
          if (response.data.code == 0) {
            var back = response.data.obj;
            if (back) {
              this.posttxt = JSON.parse(back.posttxt)
              this.ordertype = this.posttxt.Head.OrderType
              this.supplyBack = back;
              var backT = JSON.parse(back.backtxt);
              this.dmscode = backT.DMSPlusNumber;
              if (this.ordertype == 'GeneralOrder') {//数量类型订单  不用扫码
                this.saveData();
                return;
              }

              if (!backT.DMSPlusNumber)
                return;

              var backItem = JSON.parse(backT.Items || backT.items);

              if (backItem) {
                for (let i in backItem) {
                  var items = '';
                  try {
                    items = JSON.parse(backItem[i].Lens)
                  } catch (ex) {
                    items = backItem[i].Lens
                  }
                  var X = parseFloat(backItem[i].CYL).toFixed(2);
                  var Y = parseFloat(backItem[i].SPH).toFixed(2);
                  var side = backItem[i].Side;
                  if (side&&existType) {
                    if (side == 'Right' || side == 'R') {
                      side = ',"type":"R"'
                    } else if (side == 'Left' || side == 'L') {
                      side = ',"type":"L"'
                    } else {
                      side = '';
                    }
                  } else
                    side = '';
                  var eye = backItem[i].EYE;

                  for (let j in items) {
                    scancodes.push({
                      "seedcode": seedcode,
                      "erpserial": controlData.erpserial,
                      "packagesize": '{"X":"' + X + '","Y":"' + Y + '"' + side + '}',
                      "totalnumber": 1,
                      "storegoodsbarcode": items[j].LogisticCode,
                      "goodsbarcode": backItem[i].OpcCode ? backItem[i].OpcCode : '',
                      "R/L": eye ? eye : ''
                    })
                  }
                }
                if (scancodes.length > 0) {
                  this.loading = false;
                  return;
                }
              }

              //直接从依视路系统里取
              getLogisticCode({
                dmsplusnumber: backT.DMSPlusNumber,
                pcustomerserial: this.pcustomerserial
              }).then(response => {

                var backList = response.data.obj.Items;
                if (backList) {//"[{"LineNo": 1, "ProductCode": "943100A411-C","OpcCode":"", "Quantity": 2, "EYE": "", "SPH": "-0.50", "CYL": "0.00", "ADD": "", "AXIS": "0", "Side": "Left", "Lens": [{"LogisticCode": "WSo0067915104101416"}, {"LogisticCode": "WSo0067915004101416"}]}, {"LineNo": 2, "ProductCode": "943100A411-C", "Quantity": 1, "EYE": "", "SPH": "-1.25", "CYL": "0.00", "ADD": "", "AXIS": "0", "Side": "Left", "Lens": [{"LogisticCode": "WSo0067914804101416"}]}, {"LineNo": 3, "ProductCode": "943100A411-C", "Quantity": 2, "EYE": "", "SPH": "-0.25", "CYL": "0.00", "ADD": "", "AXIS": "0", "Side": "Right", "Lens": [{"LogisticCode": "WSo0067914704101416"}, {"LogisticCode": "WSo0067914604101416"}]}, {"LineNo": 4, "ProductCode": "943100A411-C", "Quantity": 1, "EYE": "", "SPH": "-0.75", "CYL": "0.00", "ADD": "", "AXIS": "0", "Side": "Right", "Lens": [{"LogisticCode": "WSo0067914504101416"}]}, {"LineNo": 5, "ProductCode": "943100A411-C", "Quantity": 3, "EYE": "", "SPH": "-1.00", "CYL": "0.00", "ADD": "", "AXIS": "0", "Side": "Right", "Lens": [{"LogisticCode": "WSo0067914304101416"}, {"LogisticCode": "WSo0067914204101416"}, {"LogisticCode": "WSo0067914104101416"}]}]"
                  var lines = [];
                  //先拆分成单条Code

                  for (let i in backList) {

                    //批量单先不管左右眼
                    var X = parseFloat(backList[i].CYL).toFixed(2);
                    var Y = parseFloat(backList[i].SPH).toFixed(2);
                    var side = backList[i].Side;
                    if (side&&existType) {
                      if (side == 'Right' || side == 'R') {
                        side = ',"type":"R"'
                      } else if (side == 'Left' || side == 'L') {
                        side = ',"type":"L"'
                      } else {
                        side = '';
                      }
                    } else
                      side = '';
                    var eye = backList[i].EYE;

                    if (this.noscan) {
                      for (var j = 0; j < backList[i].Quantity; j++) {
                        scancodes.push({
                          "seedcode": seedcode,
                          "erpserial": controlData.erpserial,
                          "packagesize": '{"X":"' + X + '","Y":"' + Y + '"' + side + '}',
                          "totalnumber": 1,
                          "storegoodsbarcode": '',
                          "goodsbarcode": '',//backList[i].OpcCode,
                          "R/L": eye?eye:''
                        });
                      }
                    }else {
                      var items = '';
                      try {
                        items = JSON.parse(backList[i].Lens)
                      } catch (ex) {
                        items = backList[i].Lens
                      }
                      for (let j in items) {
                        scancodes.push({
                          "seedcode": seedcode,
                          "erpserial": controlData.erpserial,
                          "packagesize": '{"X":"' + X + '","Y":"' + Y + '"' + side + '}',
                          "totalnumber": 1,
                          "storegoodsbarcode": items[j].LogisticCode,
                          "goodsbarcode": backList[i].OpcCode,
                          "R/L": eye?eye:''
                        });
                      }
                    }
                  }
                }
              });
            }
          }
          this.loading = false;
        });
      },
      bindScanSpilt(seedcode){
        //取依视路传过来的唯一码
        getEssilorBackinfo({erpserial: this.controlData.erpserial}).then(response => {
          if (response.data.code == 0) {
            var data = response.data.obj;
            this.SpiltData = [];
            var back = data[0];
            this.posttxt = JSON.parse(back.posttxt)
            this.ordertype = this.posttxt.Head.OrderType
            this.supplyBack = back;
            this.dmscode = '';

            for (let i in data) {
              if (data[i].backtxt == null)
                continue;

              var backT = JSON.parse(data[i].backtxt);
              if (!backT.DMSPlusNumber)
                continue;

              var backItem = JSON.parse(backT.Items || backT.items);
              var R = '';
              var L = '';

              if (backItem) {
                for (let i in backItem) {
                  var items = '';
                  try {
                    items = JSON.parse(backItem[i].Lens)
                  } catch (ex) {
                    items = backItem[i].Lens
                  }
                  var X = parseFloat(backItem[i].CYL).toFixed(2);
                  var Y = parseFloat(backItem[i].SPH).toFixed(2);
                  var side = '';
                  var eye = backItem[i].EYE;

                  for (let j in items) {
                    this.scancodes.push({
                      "seedcode": seedcode,
                      "erpserial": this.controlData.erpserial,
                      "packagesize": '{"X":"' + X + '","Y":"' + Y + '"' + side + '}',
                      "totalnumber": 1,
                      "storegoodsbarcode": items[j].LogisticCode,
                      "goodsbarcode": backItem[i].OpcCode ? backItem[i].OpcCode : '',
                      "R/L": eye ? eye : ''
                    })
                    if (eye == 'R') R = items[j].LogisticCode;
                    if (eye == 'L') L = items[j].LogisticCode;
                  }
                }

                var tracking_number_dict = '';
                if (R && L) {
                  tracking_number_dict = '{"R":["' + R + '"],"L":["' + L + '"]}';
                } else {
                  if (R) {
                    tracking_number_dict = '{"R":["' + R + '"]}';
                  } else {
                    tracking_number_dict = '{"L":["' + L + '"]}';
                  }
                }
                var para = '{"params":{"data":{"nba_reference":"' + backT.DMSPlusNumber + '","replace":true,"tracking_number_dict":' + tracking_number_dict + '}}}';
                this.SpiltData.push({pa: para});
              }
            }
          }
          this.loading = false;
        });
      }
    },
    mounted() {
    },
    components: {
    }
  }
</script>


<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>



// WEBPACK FOOTER //
// src/components/testorder/buyagreement/ScanCodeSupplyer4Buy.vue